export * from './mobile-app-legal-footer.component'
